import { z } from "zod";

// If `id` exists, we use the existing image, otherwise require a new file
const Adduniversityschema = z.object({
  university_image: z
    .any()
    .refine((val) => val !== undefined && val !== null, {
      message: "University image is required",
    }),
  university_name: z
    .string()
    .nonempty("University name is required")
    .trim()
    .min(2, "University name must be at least 2 characters"),
  university_domain: z
    .string()
    .nonempty("University domain is required")
    .trim()
    .regex(
      /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Enter a valid university domain"
    ),
});

export default Adduniversityschema;
